"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEnvironmentSettings = exports.defaultEntityReadingsHotColdSettings = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const defaultHotColdSettings = { cronStr: '0 * * * *' };
exports.defaultEntityReadingsHotColdSettings = { cronStr: '0 0 * * *' };
/*
* hotColdStorageCron is used by Widewake to set the period for saving data which has specifically
* been added to Redis by redisHotPut functions to DynamoDB
* */
const defaultTypeHotColdSettings = {
    default: defaultHotColdSettings,
    Entity: exports.defaultEntityReadingsHotColdSettings,
    Gateway: defaultHotColdSettings,
    Device: defaultHotColdSettings,
    LNS: defaultHotColdSettings
};
const defaultNetworkDataStorageSetting = {
    Source: 'S3',
};
exports.defaultEnvironmentSettings = {
    dev: {
        NetworkData: defaultNetworkDataStorageSetting,
        ECS: {
            hotColdStorageCron: defaultTypeHotColdSettings,
            hotColdStorageDelayMs: {
                Entity: iotv_v3_types_1.Milliseconds.DAY
            }
        }
    },
    test: {
        NetworkData: defaultNetworkDataStorageSetting,
        ECS: {
            hotColdStorageCron: defaultTypeHotColdSettings,
            hotColdStorageDelayMs: {
                Entity: iotv_v3_types_1.Milliseconds.DAY
            }
        }
    },
    prod: {
        NetworkData: defaultNetworkDataStorageSetting,
        ECS: {
            hotColdStorageCron: defaultTypeHotColdSettings,
            hotColdStorageDelayMs: {
                Entity: iotv_v3_types_1.Milliseconds.DAY
            }
        }
    },
};
